window.app_models.invoice_request = {
    "id":null,
    "user_id": null,
    "user": {},
    "hotel_placement_id": null,
    "hotel_placement_room_id": null,
    "start_date": null,
    "end_date": null,
    "folios_completed": null,
    "invoiceable": null,
    "what_for": null,
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/invoice_request.js